module.exports = __webpack_public_path__ + "static/fairwood-9c5dc0ef87c6ee2831b4d16ad47477e6.png";